import React from 'react';
import { Typography } from 'antd';
import { HourGlassStatusIcon } from 'assets';
import { requestform } from 'messages';

interface RequestStatusBarProps {
  status: string;
}

const getStatusInfo = (status: string) => {
  const statusMap: Record<string, { name: string; color: string }> = {
    CHUYENTRUNGTAM: { name: 'Chuyển trung tâm', color: '#AF52DE' },
    TRUONGCACHUYENPHONG: { name: 'Chuyển phòng CSKH', color: '#AF52DE' },
    TRUONGCACHUYENPHONGKYTHUAT: { name: 'Chuyển phòng KT', color: '#AF52DE' },

    pending_reception: { name: 'Chờ tiếp nhận', color: '#FF9500' },
    in_progress: { name: 'Đang xử lý', color: '#1564E8' },
    collaboration: { name: 'Phối hợp xử lý', color: '#AF52DE' },
    completed: { name: 'Đã xử lý', color: '#02D8A0' },
    obstacle: { name: 'Trở ngại', color: '#D1131D' },

    CHOTIEPNHAN: { name: 'Chờ tiếp nhận', color: '#FF9500' },
    DANGXULY: { name: 'Đang xử lý', color: '#1564E8' },
    HOANTAT: { name: 'Đã xử lý', color: '#02D8A0' },

    complaint: { name: 'Chờ xác nhận', color: '#02D8A0' },
    electrical_safety: { name: 'Chờ xác nhận', color: '#FF4D4F' },
    vip_customer: { name: 'Chờ xác nhận', color: '#1890FF' },
    outage_entire_area: { name: 'Chờ xác nhận', color: '#722ED1' },
    not_on_time: { name: 'Chờ xác nhận', color: '#13C2C2' },

    address_change: { name: 'Chờ xác nhận', color: '#FF9500' },
    completed_new_address_change: { name: 'Đã xác nhận', color: '#02D8A0' },
    power_company_request: { name: 'Điện lực chuyển yêu cầu', color: '#D1131D' }
  };

  return statusMap[status] || { name: 'Không xác định', color: 'gray' };
};

const TicketStatusBar: React.FC<RequestStatusBarProps> = ({ status }) => {
  return (
    <div
      style={{ background: getStatusInfo(status).color }}
      className={`mt-3 flex justify-between rounded-[5px] px-4 py-[11px]`}
    >
      <div>
        <Typography.Text className='text-[14px]/[18px] font-semibold text-[#FFFFFF]'>
          {requestform.detailStatusRequestForm}
        </Typography.Text>{' '}
        <Typography.Text className='text-[14px]/[18px] text-[#FFFFFF]'>{getStatusInfo(status).name}</Typography.Text>
      </div>
      <HourGlassStatusIcon />
    </div>
  );
};

export default TicketStatusBar;
